import React, { PureComponent } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import RavenUtil from '../../../../common/ravenUtil';
import { strings, getCurrentLocale } from '../../../../../localization';

import ShareTripButton from '../../shareTripButton';
import PreviewFaceButton from '../../PreviewFaceButton';
import LocationLabel from '../../LocationLabel';

import StatusIcon from 'APP_ROOT/components/common/StatusIcon';

export default class VehicleInfo extends PureComponent {

    render() {

        const shutdownByUser = RavenUtil.isShutdownByUser(this.props.raven.dashboard) ? true : false; // collapsing nulls and falses to false
        const lowBatteryShutdown = RavenUtil.isShutDownForLowBattery(this.props.raven.dashboard) ? true : false;
        const suspended = RavenUtil.isSuspended(this.props.raven) ? true : false; // collapsing nulls and falses to false

        return (
            
            <div className="row section-wrapper">
                <div className="col-12 section-header">
                    <h3>
                        {this.props.raven.vehicle.name}
                    </h3>
                    <div>
                        {this.props.features.debug && <PreviewFaceButton ravenUuid={this.props.raven.ravenUuid} mqttService={this.props.mqttService} /> }
                        <ShareTripButton
                            stage={this.props.stage}
                            ravenUuid={this.props.raven.ravenUuid}
                        />
                    </div>
                </div>
                <div className="col-12 section-body">
                    <div className="row">
                        {this.renderDriverAndPassengerInfo()}
                        <div className="trip-info">
                            {this.renderOfflineUnplugged(shutdownByUser, suspended, lowBatteryShutdown)}

                            { suspended ?  null: this.renderSDCard() }
                            { suspended ?  null: this.renderSpeed() }
                            { suspended ?  null: this.renderFuel() }
                            { suspended ?  null: this.renderTripInfo() }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderSpeed() {
        const { raven } = this.props;
        if (!raven.isDriving) return [
            <div key="speed" className="info-item speed">
                <div key="label" className="label"><StatusIcon theme={this.props.theme} type="parked" />{strings.parked_heading}</div>
                <div key="value" className="value"></div>
            </div>
        ];
        // TODO: rewrite this component so awfulness like this check is not needed
        if(!raven.vehicleState || (!raven.vehicleState.currentSpeed && raven.vehicleState.currentSpeed !== 0)) {
            return (
                <div key="speed" className="info-item speed">
                    <div key="label" className="label">
                        <span className="icon-container">
                            <img src={this.props.theme === 'light' ? '/images/icon-speed.png' : '/images/icon-speed-white.png'}
                                alt="Speed"
                                className="icon-sm" />
                        </span>
                        {strings.formatString(strings.db_raven_speed)}
                    </div>
                    <div key="value" className="value"></div>
                </div>
            );
        }

        var distanceUnits = (this.props.unitOfMeasure === "METRIC");

        var currentSpeed = isFinite(raven.vehicleState.currentSpeed) ? raven.vehicleState.currentSpeed.toString() : '0';
        if (currentSpeed.indexOf('.') > -1) {
            currentSpeed = currentSpeed.slice(0, currentSpeed.indexOf('.'));
        }
        var speedString = isFinite(currentSpeed) ? RavenUtil.round(RavenUtil.convertDistance(currentSpeed, this.props.unitOfMeasure), 1) + (distanceUnits ? ' kph' : ' mph') : "--";
        return (
            <div key="speed" className="info-item speed">
                <div key="label" className="label">
                    <span className="icon-container">
                        <img src={this.props.theme === 'light' ? '/images/icon-speed.png' : '/images/icon-speed-white.png'}
                            alt="Speed"
                            className="icon-sm" />
                    </span>
                    {strings.formatString(strings.db_raven_speed)}
                </div>
                <div key="value" className="value">
                    {speedString}
                </div>
            </div>
        )
    }

    renderFuel() {


        var fuelString =  "- -"; // initializing blank (not supported)
        // now check if supported (if there is a value available)
        if (this.props.raven.vehicleState
            && this.props.raven.vehicleState.currentFuel
            && typeof this.props.raven.vehicleState.currentFuel === 'number') {
            let currentFuelNumber = Math.round(this.props.raven.vehicleState.currentFuel);
            fuelString = currentFuelNumber + "%";
        }

        return (
            <div key="fuel" className="info-item fuel">
                <div key="label" className="label">
                    <i className="icon-container material-icons">local_gas_station</i>
                    {strings.formatString(strings.db_raven_current_fuel)}
                </div>
                <div key="value" className="value">
                    {fuelString}
                </div>
            </div>
        )
    }

    renderUserShutdown(shutdownByUser, suspended) {
        if (suspended) {
            return (
                <StatusIcon theme={this.props.theme} type="suspended" title={strings.status_suspended} />
            );
        }
        if (shutdownByUser) {
            return (
                <StatusIcon theme={this.props.theme} type="unplugged" title={strings.status_user_shutdown} />
            );
        }
    }

    renderLowBatteryShutdown(lowBatteryShutdown) {
        if (lowBatteryShutdown) {
            return (
                <StatusIcon theme={this.props.theme} type="car-battery-low" title={strings.status_low_battery_shutdown} />
            );
        }
    }

    renderOfflineUnplugged(shutdownByUser, suspended, lowBatteryShutdown) {

        var texts = [];
        var icons = [];
        var unpluggedTitle = shutdownByUser ? strings.status_user_shutdown : strings.status_unplugged;

        if (suspended) {
            texts.push(strings.status_suspended);
            icons.push(<StatusIcon key={icons.length} theme={this.props.theme} type="suspended" title={strings.status_suspended} size="tiny"/>);
        } else if (lowBatteryShutdown) {
            texts.push(strings.status_low_battery_shutdown);
            icons.push(<StatusIcon key={icons.length} theme={this.props.theme} type="car-battery-low" title={strings.status_low_battery_shutdown} size="tiny"/>);
        } else if (this.props.unplugged || shutdownByUser) {
            texts.push(unpluggedTitle);
            // icons.push(<i className="icon-container material-icons">power_off</i>);
            icons.push(<StatusIcon key={icons.length} theme={this.props.theme} type="unplugged" title={unpluggedTitle} size="tiny"/>);
        } else if (this.props.raven.vehicleState && this.props.raven.vehicleState.ravenOffline) {
            texts.push(strings.formatString(strings.db_raven_offline));
            // icons.push(<i className="icon-container material-icons">signal_cellular_off</i>);
            icons.push(<StatusIcon key={icons.length} theme={this.props.theme} type="offline" title={strings.status_offline} size="tiny"/>);
        }

        if(texts.length === 0)
        {
            // All good, we are online
            return (
                <div key="offline" className="info-item offline">
                    <div key="label" className="label">
                        <StatusIcon theme={this.props.theme} type="online" title={strings.status_online} size="tiny"/>
                        { strings.formatString(strings.db_raven_online) }
                    </div>
                    <div key="value" className="value">
                    </div>
                </div>
            );
        }
        else
        {
            return (
                <div key="offline" className="info-item offline">
                    <div key="label" className="label">
                        { icons }
                        { texts.join(", ")}
                    </div>
                    <div key="value" className="value">
                    </div>
                </div>
            );
        }
    }

    renderSDCard() {

        switch (this.props.sdCardStatus) {
            case "INSERTED":
                return (
                    <div key="sdcard" className="info-item sdcard">
                        <div key="label" className="label">
                            <StatusIcon theme={this.props.theme} type="sdcard" title={document.getSDCardStatusName(this.props.sdCardStatus)} size="tiny"/>
                            { document.getSDCardStatusName(this.props.sdCardStatus) }
                        </div>
                        <div key="value" className="value"></div>
                    </div>
                )
            case "REMOVED":
                return (
                    <div key="sdcard" className="info-item sdcard">
                        <div key="label" className="label">
                            { /* <i className="icon-container material-icons">sd_storage</i> */ }
                            <StatusIcon theme={this.props.theme} type="sdcard-no" title={document.getSDCardStatusName(this.props.sdCardStatus)} size="tiny"/>
                            { document.getSDCardStatusName(this.props.sdCardStatus) }
                        </div>
                        <div key="value" className="value"></div>
                    </div>
                )
            default:
                if (this.props.sdCardStatus !== "UNKNOWN") { // unknown is used by default for case(s) like raven is unplugged
                    return (
                        <div key="sdcard" className="info-item sdcard">
                            <div key="label" className="label">
                                { /* <i className="icon-container material-icons">sd_storage</i> */ }
                                <StatusIcon theme={this.props.theme} type="sdcard-alert" title={document.getSDCardStatusName(this.props.sdCardStatus)} size="tiny"/>
                                { document.getSDCardStatusName(this.props.sdCardStatus) }
                            </div>
                            <div key="value" className="value"></div>
                        </div>
                    )
                }
        }
        return (
            <div key="sdcard" className="info-item sdcard">
                <div key="label" className="label"></div>
                <div key="value" className="value"></div>
            </div>
        )
    }

    renderDriverAndPassengerInfo() {

        if (!this.props.features || typeof this.props.features.facial_recognition === 'undefined') {
            return null;
        } else if (!this.props.features.facial_recognition) {
            return null;
        } else if (this.props.raven.isDriving === false) {
            return null; // effectively, do not show unknown_driver/no_driver_detected for parked cards
        }

        var driverName = null;
        if (this.props.raven) {
            if (this.props.raven.vehicle) {
                if (this.props.raven.vehicle.currentDriver) {
                    if (this.props.raven.vehicle.currentDriver.name) {
                        driverName = this.props.raven.vehicle.currentDriver.name;
                    } else {
                        driverName = strings.unknown_driver;
                    }
                } else {
                    driverName = strings.no_driver_detected;
                }
            }
        }

        if (!driverName) {
            return null;
        }

        return (
            <div className="driver-occupants-info">
                <span className="drivername">{driverName}</span>
            </div>
        )
    }

    renderTripInfo() {

        var raven = this.props.raven;
        if (raven && raven.dashboard) {

            var startTimeLabel = "-";

            if (raven.dashboard.start) {
                if (raven.dashboard.start.ts) {
                    startTimeLabel = RavenUtil.toDate(raven.dashboard.start.ts).toLocaleString(getCurrentLocale(), {month: "short", day: "numeric", hour: "numeric", minute: "numeric"})
                }
            }

            var drivingTimeLabel = "-";
            var parkedTime = RavenUtil.getParkedTime(raven.dashboard);
            try {
                var startTime = raven.dashboard.start ? new Date(RavenUtil.convertTs(raven.dashboard.start.ts)) : null;
                if (parkedTime) startTime = new Date(RavenUtil.convertTs(parkedTime));
                var currentTime = new Date();
                if (!startTime) startTime = new Date(); // If start time is still null, set it to now
                var duration = moment.duration(currentTime.getTime() - startTime.getTime());
                drivingTimeLabel = duration.humanize();
            } catch (e) {
                console.error("Trip duration error", e);
            }

            var drivingStatusIcon = <i className="icon-container material-icons">directions_car</i>;
            if (!raven.isDriving) {
                drivingStatusIcon = <StatusIcon theme={this.props.theme} type="parked" />
            }
        
            return [
                <div key="start-time" className="info-item start-time">
                    <div key="label" className="label"><i className="icon-container material-icons">access_time</i>{strings.formatString(strings.db_raven_trip_start_time_label)}</div>
                    <div key="value" className="value">{startTimeLabel}</div>
                </div>,
                <div key="location-start" className="info-item location-start">
                    <div key="label" className="label"><i className="icon-container material-icons">location_on</i>{strings.formatString(strings.db_raven_trip_start_location_label)}</div>
                    <div key="value" className="value"><LocationLabel withStreetNumber={true} location={raven.dashboard.start} addMapLink /></div>
                </div>,
                <div key="location-current" className="info-item location-current">
                    <div key="label" className="label"><i className="icon-container material-icons">location_on</i>{strings.formatString(strings.db_raven_trip_current_location_label)}</div>
                    <div key="value" className="value"><LocationLabel withStreetNumber={!raven.isDriving} location={raven.lastLocation} addMapLink /></div>
                </div>,
                <div key="driving-status" className="info-item driving-status">
                    <div key="label" className="label">{drivingStatusIcon}{strings.formatString(strings.db_raven_trip_duration_label)}</div>
                    <div key="value" className="value">
                        <MomentHumanizeTimeAgo
                            dateAgo={startTime}
                            interval={5000}
                        />
                    </div>
                </div>,
                <div key="distance" className="info-item distance">
                    <div key="label" className="label"><i className="icon-container material-icons">timeline</i>{strings.formatString(strings.db_raven_trip_distance_label)}</div>
                    <div key="value" className="value">{isFinite(raven.tripDistance) ? RavenUtil.distanceString(raven.tripDistance, this.props.unitOfMeasure) : "-"}</div>
                </div>
            ]
        } else {

            return null;
        }
    }
}

class MomentHumanizeTimeAgo extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            humanizeString: null
        }

        this.interval = undefined;
    }

    humanize = () => {
        if (!this.props.dateAgo) {
            return;
        }

        const duration = moment.duration(new Date().getTime() - this.props.dateAgo.getTime());

        this.setState({
            humanizeString: duration.humanize()
        })
    }

    componentDidMount() {

        this.humanize();

        this.interval = setInterval(() => {
            this.humanize();
        }, this.props.interval || 5000 );
    }

    componentDidUpdate() {
        this.humanize();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return <>{this.state.humanizeString}</>
    }
}

const geoFeaturesPropTypes = PropTypes.arrayOf(PropTypes.shape({
    place_type: PropTypes.arrayOf(PropTypes.string),
    address: PropTypes.string,
    text: PropTypes.string,
    /* poi */
    properties: PropTypes.shape({
        address: PropTypes.string
    }),
}));

VehicleInfo.propTypes = {
    /* renderSpeed, renderFuel */
    theme: PropTypes.string.isRequired,
    /* everything */
    raven: PropTypes.shape({
        /* header */
        vehicle: PropTypes.shape({
            name: PropTypes.string,
            currentDriver: PropTypes.object
        }),
        isDriving: PropTypes.bool.isRequired,
        vehicleState: PropTypes.shape({
            /* renderSpeed */
            currentSpeed: PropTypes.number,
            /* renderFuel */
            fuel: PropTypes.number,
            /* renderOffline */
            ravenOffline: PropTypes.bool,
        }),
        /* renderSpeed, renderTripInfo */
        distanceUnits: PropTypes.number,
        /* renderUnplugged */
        unplugged: PropTypes.bool.isRequired,
        /* renderTripInfo */
        dashboard: PropTypes.shape({
            /* .getParkedTime */
            route: PropTypes.arrayOf(PropTypes.shape({
                ts: PropTypes.oneOfType([
                    PropTypes.string, // from Kloud card/dashboard responses
                    PropTypes.number  // from MQTT
                ])
            })),
            /* startTimeLabel, .getParkedTime */
            start: PropTypes.shape({
                ts: PropTypes.string
            }),
            /* .getParkedTime */
            events: PropTypes.arrayOf(PropTypes.shape()),
            type: PropTypes.string,
        }),
        /* renderTripInfo */
        tripDistance: PropTypes.number,
        /* .getLocationString */
        startReverseGeocodeFeatures: geoFeaturesPropTypes,
        reverseGeocodeFeatures: geoFeaturesPropTypes,
    }),
    /* ShareTripButton */
    ravenUuid: PropTypes.string,
    stage: PropTypes.string.isRequired,
    unitOfMeasure: PropTypes.string.isRequired,
};
